import { css } from 'styled-components';
import { FontLineHeightNone, FontWeightSemiBold } from 'autogen/design-tokens/tokens';

const ButtonTextStyling = css`
    line-height: ${FontLineHeightNone};
    font-weight: ${FontWeightSemiBold};
    text-align: center;
`;

export default ButtonTextStyling;
